import {useRef} from "react"
import Text from "../../components/input/text";
import Button from "../../components/button";
import Alert from "../../components/alert";
import UseGetFormData from "../../hooks/UseGetFormData";
import {account_address, account_info, account_providers} from "../../config/tips";
import Select from "../../components/input/select";
import Tabs from "rc-tabs";
import TabPane from "rc-tabs/lib/TabPanelList/TabPane";
import {Info, MapPin} from "react-feather";
import Email from "../../components/input/email";
import TabLabel from "../../components/tabLabel";
import {Enums} from "../../config/Config";
import {FiSend} from "react-icons/fi";

const Form = (props) => {
    const {account, plans, providers, errors, isReady, onSubmit} = props

    const formRef = useRef()
    const infoTab = <TabLabel slug="info" label="Info" icon={<Info/>} errors={errors}/>
    const addressLimit = <TabLabel slug="address" label="Address" icon={<MapPin/>} errors={errors}/>
    const providersTab = <TabLabel slug="providers" label="Providers" icon={<FiSend/>} errors={errors}/>


    const handleSubmit = (ev) => {
        ev.preventDefault()
        const FormData = UseGetFormData(formRef)
        onSubmit({
            info     : {
                name  : FormData.get('name'),
                plan  : FormData.get('plan'),
                status: FormData.get('status'),
            },
            company  : {
                name      : FormData.get('name'),
                email     : FormData.get('email'),
                phone     : FormData.get('phone'),
                vat_number: FormData.get('vat_number'),
            },
            address  : {
                address: FormData.get('address'),
                city   : FormData.get('city'),
                country: FormData.get('country'),
                state  : FormData.get('state'),
                zipcode: FormData.get('zipcode'),
            },
            providers: {
                sms  : FormData.get('sms_provider'),
                email: FormData.get('email_provider'),
            }
        })
    }


    return (
        <form autoComplete="off" ref={formRef} onSubmit={handleSubmit}>
            <Tabs defaultActiveKey="0">
                <TabPane forceRender={true} key={'origin'} tabKey={'origin'} tab={infoTab}>
                    <Alert
                        icon="info"
                        docsPath="/docs/accounts"
                        message={account_info}
                    />

                    <Select required
                        size="md"
                        name="plan"
                        label="Plan"
                        options={plans}
                        isReady={isReady}
                        value={account?.plan?.$oid}
                        error={errors && errors['info.plan']}
                        placeholder="Choose a plan for this account"
                    />

                    <Select required
                        size="md"
                        name="status"
                        label="Status"
                        isReady={isReady}
                        value={account?.status}
                        options={Enums.status.accounts}
                        error={errors && errors['info.status']}
                        placeholder="Please choose status"
                    />

                    <Text required
                        size="md"
                        name="name"
                        label="Company Name"
                        isReady={isReady}
                        value={account?.name}
                        placeholder="Type account name..."
                        error={errors && errors['info.name']}
                    />

                    <Email
                        size="md"
                        name="email"
                        label="Email Address"
                        isReady={isReady}
                        value={account?.company?.email}
                        error={errors && errors['company.email']}
                        placeholder="Type primary email"
                    />

                    <Text
                        size="md"
                        name="phone"
                        label="Phone Number"
                        isReady={isReady}
                        value={account?.company?.phone}
                        placeholder="Type account phone..."
                        error={errors && errors['company.phone']}
                    />

                    <Text
                        size="md"
                        name="vat_number"
                        label="Tax Number"
                        isReady={isReady}
                        value={account?.company?.vat_number}
                        placeholder="Type company vat number..."
                        error={errors && errors['company.vat_number']}
                    />

                </TabPane>
                <TabPane forceRender={true} key={'address'} tabKey={'address'} tab={addressLimit}>
                    <Alert
                        icon="info"
                        docsPath="/docs/plans"
                        message={account_address}
                    />

                    <Text
                        size="md"
                        name="country"
                        label="Country"
                        isReady={isReady}
                        value={account?.address?.country}
                        placeholder="Type account country..."
                        error={errors && errors['address.country']}
                    />

                    <Text
                        size="md"
                        name="state"
                        label="State"
                        isReady={isReady}
                        value={account?.address?.state}
                        placeholder="Type account state..."
                        error={errors && errors['address.state']}
                    />

                    <Text
                        size="md"
                        name="city"
                        label="City"
                        isReady={isReady}
                        value={account?.address?.city}
                        placeholder="Type account city..."
                        error={errors && errors['address.city']}
                    />

                    <Text
                        size="md"
                        name="zipcode"
                        label="Zip Code"
                        isReady={isReady}
                        value={account?.address?.zipcode}
                        placeholder="Type account zip code..."
                        error={errors && errors['address.zipcode']}
                    />

                    <Text
                        size="md"
                        name="address"
                        label="Address"
                        isReady={isReady}
                        value={account?.address?.address}
                        placeholder="Type account address..."
                        error={errors && errors['address.address']}
                    />


                </TabPane>
                <TabPane forceRender={true} key={'features'} tabKey={'features'} tab={providersTab}>

                    <Alert
                        icon="info"
                        docsPath="/docs/plans"
                        message={account_providers}
                    />

                    <Select required
                        size="md"
                        name="sms_provider"
                        label="Sms Provider"
                        isReady={isReady}
                        value={account?.providers?.sms?.$oid}
                        options={providers.sms}
                        error={errors && errors['providers.sms']}
                        placeholder="Choose a provider"
                    />

                    <Select required
                        size="md"
                        name="email_provider"
                        label="Email Provider"
                        isReady={isReady}
                        value={account?.providers?.email?.$oid}
                        options={providers.email}
                        error={errors && errors['providers.email']}
                        placeholder="Choose a provider"
                    />
                </TabPane>
            </Tabs>

            <Button
                size="sm"
                color="primary"
                isReady={isReady}
                icon={account ? 'check' : 'plus'}
                label={account ? 'Update' : 'Create'}
            />

        </form>
    )
}

export default Form